export interface Country {
  code: string
  name: string
  flag: string
  defaultCurrency: string
}

export interface CurrencyInfo {
  code: string
  name: string
  symbol: string
  flag: string
}

export const CURRENCIES: CurrencyInfo[] = [
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
  { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺' },
  { code: 'GBP', name: 'British Pound', symbol: '£', flag: '🇬🇧' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', flag: '🇯🇵' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', flag: '🇨🇭' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'CA$', flag: '🇨🇦' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: '🇦🇺' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', flag: '🇳🇿' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', flag: '🇸🇬' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', flag: '🇭🇰' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', flag: '🇨🇳' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', flag: '🇮🇳' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', flag: '🇰🇷' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', flag: '🇧🇷' },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'Mex$', flag: '🇲🇽' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: '🇿🇦' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', flag: '🇸🇪' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', flag: '🇳🇴' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr', flag: '🇩🇰' },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', flag: '🇵🇱' },
  { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč', flag: '🇨🇿' },
  { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft', flag: '🇭🇺' },
  { code: 'TRY', name: 'Turkish Lira', symbol: '₺', flag: '🇹🇷' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿', flag: '🇹🇭' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', flag: '🇲🇾' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱', flag: '🇵🇭' },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', flag: '🇮🇩' },
  { code: 'VND', name: 'Vietnamese Dong', symbol: '₫', flag: '🇻🇳' },
  { code: 'TWD', name: 'New Taiwan Dollar', symbol: 'NT$', flag: '🇹🇼' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', flag: '🇦🇪' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', flag: '🇸🇦' },
  { code: 'ILS', name: 'Israeli New Shekel', symbol: '₪', flag: '🇮🇱' },
  { code: 'RUB', name: 'Russian Ruble', symbol: '₽', flag: '🇷🇺' },
  { code: 'ARS', name: 'Argentine Peso', symbol: '$', flag: '🇦🇷' },
  { code: 'CLP', name: 'Chilean Peso', symbol: '$', flag: '🇨🇱' },
  { code: 'COP', name: 'Colombian Peso', symbol: '$', flag: '🇨🇴' },
  { code: 'PEN', name: 'Peruvian Sol', symbol: 'S/', flag: '🇵🇪' },
  { code: 'EGP', name: 'Egyptian Pound', symbol: 'E£', flag: '🇪🇬' },
  { code: 'NGN', name: 'Nigerian Naira', symbol: '₦', flag: '🇳🇬' },
  { code: 'KES', name: 'Kenyan Shilling', symbol: 'KSh', flag: '🇰🇪' },
  { code: 'MAD', name: 'Moroccan Dirham', symbol: 'MAD', flag: '🇲🇦' },
  { code: 'RON', name: 'Romanian Leu', symbol: 'lei', flag: '🇷🇴' },
  { code: 'BGN', name: 'Bulgarian Lev', symbol: 'лв', flag: '🇧🇬' },
  { code: 'HRK', name: 'Croatian Kuna', symbol: 'kn', flag: '🇭🇷' },
  { code: 'ISK', name: 'Icelandic Króna', symbol: 'kr', flag: '🇮🇸' },
  { code: 'PKR', name: 'Pakistani Rupee', symbol: '₨', flag: '🇵🇰' },
  { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳', flag: '🇧🇩' },
  { code: 'LKR', name: 'Sri Lankan Rupee', symbol: 'Rs', flag: '🇱🇰' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'ر.ق', flag: '🇶🇦' },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', flag: '🇰🇼' },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: '.د.ب', flag: '🇧🇭' },
  { code: 'OMR', name: 'Omani Rial', symbol: 'ر.ع.', flag: '🇴🇲' },
  { code: 'JOD', name: 'Jordanian Dinar', symbol: 'د.ا', flag: '🇯🇴' },
  { code: 'LBP', name: 'Lebanese Pound', symbol: 'ل.ل', flag: '🇱🇧' },
  { code: 'UAH', name: 'Ukrainian Hryvnia', symbol: '₴', flag: '🇺🇦' },
  { code: 'KZT', name: 'Kazakhstani Tenge', symbol: '₸', flag: '🇰🇿' },
  { code: 'UZS', name: 'Uzbekistani Som', symbol: 'soʻm', flag: '🇺🇿' },
  { code: 'GHS', name: 'Ghanaian Cedi', symbol: 'GH₵', flag: '🇬🇭' },
  { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh', flag: '🇹🇿' },
  { code: 'UGX', name: 'Ugandan Shilling', symbol: 'USh', flag: '🇺🇬' },
  { code: 'XOF', name: 'CFA Franc BCEAO', symbol: 'CFA', flag: '🌍' },
  { code: 'XAF', name: 'CFA Franc BEAC', symbol: 'FCFA', flag: '🌍' },
]

export const COUNTRIES: Country[] = [
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', defaultCurrency: 'AFN' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱', defaultCurrency: 'ALL' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿', defaultCurrency: 'DZD' },
  { code: 'AS', name: 'American Samoa', flag: '🇦🇸', defaultCurrency: 'USD' },
  { code: 'AD', name: 'Andorra', flag: '🇦🇩', defaultCurrency: 'EUR' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', defaultCurrency: 'AOA' },
  { code: 'AI', name: 'Anguilla', flag: '🇦🇮', defaultCurrency: 'XCD' },
  { code: 'AQ', name: 'Antarctica', flag: '🇦🇶', defaultCurrency: 'USD' },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    defaultCurrency: 'XCD',
  },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', defaultCurrency: 'ARS' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲', defaultCurrency: 'AMD' },
  { code: 'AW', name: 'Aruba', flag: '🇦🇼', defaultCurrency: 'AWG' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', defaultCurrency: 'AUD' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', defaultCurrency: 'EUR' },
  { code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿', defaultCurrency: 'AZN' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', defaultCurrency: 'BSD' },
  { code: 'BH', name: 'Bahrain', flag: '🇧🇭', defaultCurrency: 'BHD' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', defaultCurrency: 'BDT' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧', defaultCurrency: 'BBD' },
  { code: 'BY', name: 'Belarus', flag: '🇧🇾', defaultCurrency: 'BYN' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', defaultCurrency: 'EUR' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿', defaultCurrency: 'BZD' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯', defaultCurrency: 'XOF' },
  { code: 'BM', name: 'Bermuda', flag: '🇧🇲', defaultCurrency: 'BMD' },
  { code: 'BT', name: 'Bhutan', flag: '🇧🇹', defaultCurrency: 'BTN' },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴', defaultCurrency: 'BOB' },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    defaultCurrency: 'BAM',
  },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼', defaultCurrency: 'BWP' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', defaultCurrency: 'BRL' },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    flag: '🇮🇴',
    defaultCurrency: 'USD',
  },
  { code: 'BN', name: 'Brunei Darussalam', flag: '🇧🇳', defaultCurrency: 'BND' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬', defaultCurrency: 'BGN' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', defaultCurrency: 'XOF' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮', defaultCurrency: 'BIF' },
  { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', defaultCurrency: 'CVE' },
  { code: 'KH', name: 'Cambodia', flag: '🇰🇭', defaultCurrency: 'KHR' },
  { code: 'CM', name: 'Cameroon', flag: '🇨🇲', defaultCurrency: 'XAF' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', defaultCurrency: 'CAD' },
  { code: 'KY', name: 'Cayman Islands', flag: '🇰🇾', defaultCurrency: 'KYD' },
  {
    code: 'CF',
    name: 'Central African Republic',
    flag: '🇨🇫',
    defaultCurrency: 'XAF',
  },
  { code: 'TD', name: 'Chad', flag: '🇹🇩', defaultCurrency: 'XAF' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', defaultCurrency: 'CLP' },
  { code: 'CN', name: 'China', flag: '🇨🇳', defaultCurrency: 'CNY' },
  { code: 'CX', name: 'Christmas Island', flag: '🇨🇽', defaultCurrency: 'AUD' },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    flag: '🇨🇨',
    defaultCurrency: 'AUD',
  },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', defaultCurrency: 'COP' },
  { code: 'KM', name: 'Comoros', flag: '🇰🇲', defaultCurrency: 'KMF' },
  { code: 'CG', name: 'Congo', flag: '🇨🇬', defaultCurrency: 'XAF' },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
    flag: '🇨🇩',
    defaultCurrency: 'CDF',
  },
  { code: 'CK', name: 'Cook Islands', flag: '🇨🇰', defaultCurrency: 'NZD' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', defaultCurrency: 'CRC' },
  { code: 'HR', name: 'Croatia', flag: '🇭🇷', defaultCurrency: 'EUR' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', defaultCurrency: 'CUP' },
  { code: 'CW', name: 'Curaçao', flag: '🇨🇼', defaultCurrency: 'ANG' },
  { code: 'CY', name: 'Cyprus', flag: '🇨🇾', defaultCurrency: 'EUR' },
  { code: 'CZ', name: 'Czechia', flag: '🇨🇿', defaultCurrency: 'CZK' },
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮', defaultCurrency: 'XOF' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', defaultCurrency: 'DKK' },
  { code: 'DJ', name: 'Djibouti', flag: '🇩🇯', defaultCurrency: 'DJF' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲', defaultCurrency: 'XCD' },
  {
    code: 'DO',
    name: 'Dominican Republic',
    flag: '🇩🇴',
    defaultCurrency: 'DOP',
  },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨', defaultCurrency: 'USD' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', defaultCurrency: 'EGP' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻', defaultCurrency: 'USD' },
  { code: 'GQ', name: 'Equatorial Guinea', flag: '🇬🇶', defaultCurrency: 'XAF' },
  { code: 'ER', name: 'Eritrea', flag: '🇪🇷', defaultCurrency: 'ERN' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪', defaultCurrency: 'EUR' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿', defaultCurrency: 'SZL' },
  { code: 'ET', name: 'Ethiopia', flag: '🇪🇹', defaultCurrency: 'ETB' },
  { code: 'FK', name: 'Falkland Islands', flag: '🇫🇰', defaultCurrency: 'FKP' },
  { code: 'FO', name: 'Faroe Islands', flag: '🇫🇴', defaultCurrency: 'DKK' },
  { code: 'FJ', name: 'Fiji', flag: '🇫🇯', defaultCurrency: 'FJD' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', defaultCurrency: 'EUR' },
  { code: 'FR', name: 'France', flag: '🇫🇷', defaultCurrency: 'EUR' },
  { code: 'GF', name: 'French Guiana', flag: '🇬🇫', defaultCurrency: 'EUR' },
  { code: 'PF', name: 'French Polynesia', flag: '🇵🇫', defaultCurrency: 'XPF' },
  {
    code: 'TF',
    name: 'French Southern Territories',
    flag: '🇹🇫',
    defaultCurrency: 'EUR',
  },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦', defaultCurrency: 'XAF' },
  { code: 'GM', name: 'Gambia', flag: '🇬🇲', defaultCurrency: 'GMD' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪', defaultCurrency: 'GEL' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', defaultCurrency: 'EUR' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', defaultCurrency: 'GHS' },
  { code: 'GI', name: 'Gibraltar', flag: '🇬🇮', defaultCurrency: 'GIP' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', defaultCurrency: 'EUR' },
  { code: 'GL', name: 'Greenland', flag: '🇬🇱', defaultCurrency: 'DKK' },
  { code: 'GD', name: 'Grenada', flag: '🇬🇩', defaultCurrency: 'XCD' },
  { code: 'GP', name: 'Guadeloupe', flag: '🇬🇵', defaultCurrency: 'EUR' },
  { code: 'GU', name: 'Guam', flag: '🇬🇺', defaultCurrency: 'USD' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', defaultCurrency: 'GTQ' },
  { code: 'GG', name: 'Guernsey', flag: '🇬🇬', defaultCurrency: 'GBP' },
  { code: 'GN', name: 'Guinea', flag: '🇬🇳', defaultCurrency: 'GNF' },
  { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼', defaultCurrency: 'XOF' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾', defaultCurrency: 'GYD' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹', defaultCurrency: 'HTG' },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    flag: '🇭🇲',
    defaultCurrency: 'AUD',
  },
  { code: 'VA', name: 'Holy See', flag: '🇻🇦', defaultCurrency: 'EUR' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', defaultCurrency: 'HNL' },
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', defaultCurrency: 'HKD' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', defaultCurrency: 'HUF' },
  { code: 'IS', name: 'Iceland', flag: '🇮🇸', defaultCurrency: 'ISK' },
  { code: 'IN', name: 'India', flag: '🇮🇳', defaultCurrency: 'INR' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', defaultCurrency: 'IDR' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', defaultCurrency: 'IRR' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶', defaultCurrency: 'IQD' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', defaultCurrency: 'EUR' },
  { code: 'IM', name: 'Isle of Man', flag: '🇮🇲', defaultCurrency: 'GBP' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', defaultCurrency: 'ILS' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', defaultCurrency: 'EUR' },
  { code: 'JM', name: 'Jamaica', flag: '🇯🇲', defaultCurrency: 'JMD' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', defaultCurrency: 'JPY' },
  { code: 'JE', name: 'Jersey', flag: '🇯🇪', defaultCurrency: 'GBP' },
  { code: 'JO', name: 'Jordan', flag: '🇯🇴', defaultCurrency: 'JOD' },
  { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿', defaultCurrency: 'KZT' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', defaultCurrency: 'KES' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮', defaultCurrency: 'AUD' },
  { code: 'KP', name: 'North Korea', flag: '🇰🇵', defaultCurrency: 'KPW' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', defaultCurrency: 'KRW' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼', defaultCurrency: 'KWD' },
  { code: 'KG', name: 'Kyrgyzstan', flag: '🇰🇬', defaultCurrency: 'KGS' },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
    flag: '🇱🇦',
    defaultCurrency: 'LAK',
  },
  { code: 'LV', name: 'Latvia', flag: '🇱🇻', defaultCurrency: 'EUR' },
  { code: 'LB', name: 'Lebanon', flag: '🇱🇧', defaultCurrency: 'LBP' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸', defaultCurrency: 'LSL' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷', defaultCurrency: 'LRD' },
  { code: 'LY', name: 'Libya', flag: '🇱🇾', defaultCurrency: 'LYD' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', defaultCurrency: 'CHF' },
  { code: 'LT', name: 'Lithuania', flag: '🇱🇹', defaultCurrency: 'EUR' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', defaultCurrency: 'EUR' },
  { code: 'MO', name: 'Macao', flag: '🇲🇴', defaultCurrency: 'MOP' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬', defaultCurrency: 'MGA' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼', defaultCurrency: 'MWK' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', defaultCurrency: 'MYR' },
  { code: 'MV', name: 'Maldives', flag: '🇲🇻', defaultCurrency: 'MVR' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', defaultCurrency: 'XOF' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', defaultCurrency: 'EUR' },
  { code: 'MH', name: 'Marshall Islands', flag: '🇲🇭', defaultCurrency: 'USD' },
  { code: 'MQ', name: 'Martinique', flag: '🇲🇶', defaultCurrency: 'EUR' },
  { code: 'MR', name: 'Mauritania', flag: '🇲🇷', defaultCurrency: 'MRU' },
  { code: 'MU', name: 'Mauritius', flag: '🇲🇺', defaultCurrency: 'MUR' },
  { code: 'YT', name: 'Mayotte', flag: '🇾🇹', defaultCurrency: 'EUR' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', defaultCurrency: 'MXN' },
  { code: 'FM', name: 'Micronesia', flag: '🇫🇲', defaultCurrency: 'USD' },
  { code: 'MD', name: 'Moldova', flag: '🇲🇩', defaultCurrency: 'MDL' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨', defaultCurrency: 'EUR' },
  { code: 'MN', name: 'Mongolia', flag: '🇲🇳', defaultCurrency: 'MNT' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪', defaultCurrency: 'EUR' },
  { code: 'MS', name: 'Montserrat', flag: '🇲🇸', defaultCurrency: 'XCD' },
  { code: 'MA', name: 'Morocco', flag: '🇲🇦', defaultCurrency: 'MAD' },
  { code: 'MZ', name: 'Mozambique', flag: '🇲🇿', defaultCurrency: 'MZN' },
  { code: 'MM', name: 'Myanmar', flag: '🇲🇲', defaultCurrency: 'MMK' },
  { code: 'NA', name: 'Namibia', flag: '🇳🇦', defaultCurrency: 'NAD' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷', defaultCurrency: 'AUD' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵', defaultCurrency: 'NPR' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', defaultCurrency: 'EUR' },
  { code: 'NC', name: 'New Caledonia', flag: '🇳🇨', defaultCurrency: 'XPF' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', defaultCurrency: 'NZD' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮', defaultCurrency: 'NIO' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪', defaultCurrency: 'XOF' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', defaultCurrency: 'NGN' },
  { code: 'NU', name: 'Niue', flag: '🇳🇺', defaultCurrency: 'NZD' },
  { code: 'NF', name: 'Norfolk Island', flag: '🇳🇫', defaultCurrency: 'AUD' },
  { code: 'MK', name: 'North Macedonia', flag: '🇲🇰', defaultCurrency: 'MKD' },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    flag: '🇲🇵',
    defaultCurrency: 'USD',
  },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', defaultCurrency: 'NOK' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲', defaultCurrency: 'OMR' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', defaultCurrency: 'PKR' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼', defaultCurrency: 'USD' },
  { code: 'PS', name: 'Palestine', flag: '🇵🇸', defaultCurrency: 'ILS' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦', defaultCurrency: 'PAB' },
  { code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬', defaultCurrency: 'PGK' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', defaultCurrency: 'PYG' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', defaultCurrency: 'PEN' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', defaultCurrency: 'PHP' },
  { code: 'PN', name: 'Pitcairn', flag: '🇵🇳', defaultCurrency: 'NZD' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', defaultCurrency: 'PLN' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', defaultCurrency: 'EUR' },
  { code: 'PR', name: 'Puerto Rico', flag: '🇵🇷', defaultCurrency: 'USD' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', defaultCurrency: 'QAR' },
  { code: 'RE', name: 'Réunion', flag: '🇷🇪', defaultCurrency: 'EUR' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴', defaultCurrency: 'RON' },
  {
    code: 'RU',
    name: 'Russian Federation',
    flag: '🇷🇺',
    defaultCurrency: 'RUB',
  },
  { code: 'RW', name: 'Rwanda', flag: '🇷🇼', defaultCurrency: 'RWF' },
  { code: 'BL', name: 'Saint Barthélemy', flag: '🇧🇱', defaultCurrency: 'EUR' },
  { code: 'SH', name: 'Saint Helena', flag: '🇸🇭', defaultCurrency: 'SHP' },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    defaultCurrency: 'XCD',
  },
  { code: 'LC', name: 'Saint Lucia', flag: '🇱🇨', defaultCurrency: 'XCD' },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
    flag: '🇲🇫',
    defaultCurrency: 'EUR',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    defaultCurrency: 'EUR',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    defaultCurrency: 'XCD',
  },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸', defaultCurrency: 'WST' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲', defaultCurrency: 'EUR' },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    defaultCurrency: 'STN',
  },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', defaultCurrency: 'SAR' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳', defaultCurrency: 'XOF' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸', defaultCurrency: 'RSD' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨', defaultCurrency: 'SCR' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱', defaultCurrency: 'SLL' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', defaultCurrency: 'SGD' },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
    flag: '🇸🇽',
    defaultCurrency: 'ANG',
  },
  { code: 'SK', name: 'Slovakia', flag: '🇸🇰', defaultCurrency: 'EUR' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮', defaultCurrency: 'EUR' },
  { code: 'SB', name: 'Solomon Islands', flag: '🇸🇧', defaultCurrency: 'SBD' },
  { code: 'SO', name: 'Somalia', flag: '🇸🇴', defaultCurrency: 'SOS' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', defaultCurrency: 'ZAR' },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    defaultCurrency: 'GBP',
  },
  { code: 'SS', name: 'South Sudan', flag: '🇸🇸', defaultCurrency: 'SSP' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', defaultCurrency: 'EUR' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', defaultCurrency: 'LKR' },
  { code: 'SD', name: 'Sudan', flag: '🇸🇩', defaultCurrency: 'SDG' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷', defaultCurrency: 'SRD' },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    flag: '🇸🇯',
    defaultCurrency: 'NOK',
  },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', defaultCurrency: 'SEK' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', defaultCurrency: 'CHF' },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
    flag: '🇸🇾',
    defaultCurrency: 'SYP',
  },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼', defaultCurrency: 'TWD' },
  { code: 'TJ', name: 'Tajikistan', flag: '🇹🇯', defaultCurrency: 'TJS' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿', defaultCurrency: 'TZS' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', defaultCurrency: 'THB' },
  { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', defaultCurrency: 'USD' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', defaultCurrency: 'XOF' },
  { code: 'TK', name: 'Tokelau', flag: '🇹🇰', defaultCurrency: 'NZD' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴', defaultCurrency: 'TOP' },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    defaultCurrency: 'TTD',
  },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳', defaultCurrency: 'TND' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', defaultCurrency: 'TRY' },
  { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲', defaultCurrency: 'TMT' },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    defaultCurrency: 'USD',
  },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', defaultCurrency: 'AUD' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬', defaultCurrency: 'UGX' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', defaultCurrency: 'UAH' },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    defaultCurrency: 'AED',
  },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', defaultCurrency: 'GBP' },
  { code: 'US', name: 'United States', flag: '🇺🇸', defaultCurrency: 'USD' },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    flag: '🇺🇲',
    defaultCurrency: 'USD',
  },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', defaultCurrency: 'UYU' },
  { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿', defaultCurrency: 'UZS' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', defaultCurrency: 'VUV' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', defaultCurrency: 'VES' },
  { code: 'VN', name: 'Viet Nam', flag: '🇻🇳', defaultCurrency: 'VND' },
  {
    code: 'VG',
    name: 'Virgin Islands (British)',
    flag: '🇻🇬',
    defaultCurrency: 'USD',
  },
  {
    code: 'VI',
    name: 'Virgin Islands (U.S.)',
    flag: '🇻🇮',
    defaultCurrency: 'USD',
  },
  { code: 'WF', name: 'Wallis and Futuna', flag: '🇼🇫', defaultCurrency: 'XPF' },
  { code: 'EH', name: 'Western Sahara', flag: '🇪🇭', defaultCurrency: 'MAD' },
  { code: 'YE', name: 'Yemen', flag: '🇾🇪', defaultCurrency: 'YER' },
  { code: 'ZM', name: 'Zambia', flag: '🇿🇲', defaultCurrency: 'ZMW' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼', defaultCurrency: 'ZWL' },
]

export function getCountry(code: string): Country {
  return (
    COUNTRIES.find((c) => c.code === code) || {
      code,
      name: 'Unknown',
      flag: '🏳️',
      defaultCurrency: 'USD',
    }
  )
}

export function getDefaultCurrency(countryCode: string): string {
  return getCountry(countryCode).defaultCurrency
}

export function getCurrencyInfo(code: string): CurrencyInfo {
  return (
    CURRENCIES.find((c) => c.code === code) || {
      code,
      name: code,
      symbol: code,
      flag: '💵',
    }
  )
}
